import { useContext } from "react";
import { Context } from "../../store";
import {
  setIndex,
  toggleContinue,
} from "../../store/reducer";

import Modal from "./Index";
import { RepeatButton, ContinueButton } from "./Buttons";

const ContinueModal = () => {
  const [{ currentItem, index, player }, dispatch] =
    useContext(Context);

  const onContinue = () => {
    dispatch(toggleContinue());
    if (currentItem.next) {
      dispatch(setIndex(currentItem.next));
    } else {
      dispatch(setIndex(index + 1));
    }
  };

  const onRepeat = () => {
    dispatch(toggleContinue());

    player.currentTime = 0;
    player.play();
  };

  return (
    <div className="flex items-center justify-between">
      <RepeatButton onClick={onRepeat} />
      <ContinueButton onClick={onContinue} />
    </div>
  );
};

export default Modal(ContinueModal);
